var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnChapterEndingBadge = function SvgIcnChapterEndingBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1984_147517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0H32V25.5682C32 26.2633 31.3084 26.7464 30.6557 26.5071L17.3443 21.6262C17.122 21.5447 16.878 21.5447 16.6557 21.6262L3.34426 26.5071C2.69164 26.7464 2 26.2633 2 25.5682V0Z",
    fill: "#2CCCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1504 15.748V11.986H14.8634V12.921H10.8264V11.997H9.52842V15.748H16.1504ZM16.1504 11.568V6.068H14.9294V8.356H14.1264V6.244H12.9274V11.502H14.1264V9.39H14.9294V11.568H16.1504ZM8.07642 8.906H9.60542C9.45142 9.863 8.84642 10.567 7.72442 11.007C7.96642 11.326 8.20842 11.634 8.45042 11.964C9.30842 11.612 10.0344 10.897 10.2984 10.171C10.5734 10.853 11.3544 11.469 11.9814 11.689L12.6084 10.721C11.7064 10.413 11.1124 9.819 10.9364 8.906H12.3884V7.905H8.07642V8.906ZM14.8634 14.725H10.8264V13.911H14.8634V14.725ZM8.98942 7.366H11.5414V6.354H8.98942V7.366ZM18.98 12.635V10.622H21.796V9.599H18.98V7.938H22.214V6.915H17.715V13.669L18.65 13.68C20.212 13.691 21.906 13.581 22.918 13.35L22.775 12.371C21.664 12.646 20.146 12.657 18.98 12.635ZM25.426 15.869V6.068H24.15V9.566H22.511V10.666H24.15V15.869H25.426Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1984_147517",
    x: 0,
    y: -1,
    width: 34,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1984_147517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1984_147517",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnChapterEndingBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_chapter_ending_badge.0fd4cce4.svg";
export { ForwardRef as ReactComponent };